// import AccountInfo from "../components/AccountInfo";
import Login from "../components/Login";
import Admin from "../components/Admin";
import CoreView from "../components/core/View";
import AppointmentDetails from "../components/AppointmentDetails";
import Scheduler from "../components/Scheduler";
import store from "../store/index";
import Thanks from "@/components/core/Thanks";
import faqs from "@/components/core/faqs";
import Terms from "@/components/core/Terms";
import Registration from "../components/Registration";

const routes = [
  {
    path: "/",
    components: {
      default: CoreView,
    },
    meta: {
      title: "Virtual House Pro - Home",
      metaTags: [
        {
          name: "description",
          content:
            "Virtual house pro helps take the guesswork out of the process and application of many of your home needs! ",
        },
        {
          property: "og:description",
          content:
            "Virtual house pro helps take the guesswork out of the process and application of many of your home needs! ",
        },
      ],
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/faqs",
    name: "faqs",
    components: {
      default: faqs,
    },
  },
  // {
  //   path: "/account",
  //   name: "account",
  //   component: AccountInfo,
  //   beforeEnter: (to, from, next) => {
  //     if (store.getters.userId) {
  //       next();
  //     } else {
  //       next({
  //         name: "home",
  //       });
  //     }
  //   },
  // },
  {
    path: "/admin/:calEventId/details",
    name: "appointmentDetails",
    component: AppointmentDetails,
    props: true,
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    beforeEnter: (to, from, next) => {
      if (store.getters.userIsAdmin) {
        next();
      } else {
        next({
          name: "login",
        });
      }
    },
  },
  {
    path: "/schedule",
    name: "schedule",
    component: Scheduler,
  },
  {
    path: "/register",
    name: "register",
    component: Registration,
  },
  {
    path: "/terms",
    name: "terms",
    components: {
      default: Terms,
    },
  },
  {
    path: "/thanks",
    name: "thanks",
    components: {
      default: Thanks,
    },
    async beforeEnter(to, from, next) {
      try {
        const hasPermission = await store.dispatch("checkBookingStatus");
        console.log("Booking Payload exists: ", hasPermission);
        if (hasPermission == true) {
          next();
        }
      } catch (e) {
        next({
          name: "schedule", // back to safety route //
        });
      }
    },
  },
];

export default routes;
